// extracted by mini-css-extract-plugin
export default {"ListContainer":"ProductDotList_ListContainer__DVgK3"};